import { ChallengeDefinitionEntity, ChallengeDefinitionProductEntity, ChallengeGoalEntity, DwProductEntity, DwProductSizeEntity } from '../../../meta-data/app-meta-data.service';

export interface PublicCatalogMedia { MediaId: number; MediaPath: string; }
export interface PublicCatalogProduct extends Omit<DwProductEntity, '_itemName'> {
    ProductType: string;
    CategoryDisplay: string;
    Sizes: Omit<DwProductSizeEntity, '_itemName'>[];
    Colors: { ProductColorId: number; Color: string }[];
    Options: { ProductOptionId: number; Details: { ProductOptionDetailId: number; DetailName: string; ExtraCost: number }[] }[];
    Media: { MediaId: number; MediaName: string; IsDefault: boolean; MediaOrder: number }[];
}
export interface PublicCatalog {
    Challenge: Omit<ChallengeDefinitionEntity, '_itemName'> & {
        Goals: Omit<ChallengeGoalEntity, '_itemName'>[];
        Media: { MediaKeyName: string; MediaId: number }[];
    };
    Products: PublicCatalogProduct[];
    ChallengeProducts: Omit<ChallengeDefinitionProductEntity, '_itemName'>[];
    Media: PublicCatalogMedia[];
}

// Keep aligned with ChallengeCatalogCacheInterceptor's complete dependency graph.
export const PUBLIC_CATALOG_ITEMS = [
    'ChallengeDefinition', 'ChallengeDefinitionProduct', 'ChallengeGoal', 'ChallengeMedia', 'ShirtSize',
    'dw_Product', 'dw_ProductType', 'dw_ProductCategory', 'dw_ProductMedia', 'dw_ProductSize',
    'dw_ProductColor', 'dw_ProductOption', 'dw_ProductOptionDetail', 'dw_Media', 'dw_MediaDetail',
];
